// Import controller interfaces
import {
    IEndorsementValidationController
} from '../Interfaces/ControllerInterfacesBarrel';
// Import api models.
import ApiController from './ApiController';
import {
    AllowedEndorsementDateRange,
    EndorsementEligibilityStatus,
    ErrorMessage,
} from '@app/models/api';

export default class ProductionEndorsementValidationController extends ApiController implements IEndorsementValidationController {
    private readonly controllerUrl: string = 'v2/endorsementValidation';

    public constructor() {
        super();
    }

    public async getEndorsementEligibilityStatus(policyId: number): Promise<EndorsementEligibilityStatus> {
        let url: string = `${this.controllerUrl}/eligibilitystatus/${policyId}`;

        try {
            let response: Response = await super.makeGetCall(url);
            return await response.json();
        }
        catch (error) {
            if (ErrorMessage.isErrorMessage(error)) {
                error.message = `Could not fetch endorsement eligibility status for policy # ${policyId}.`;
            }
            throw error;
        }
    }

    public async getAllowedEndorsementDateRange(endorsementId: number): Promise<AllowedEndorsementDateRange> {
        let url: string = `${this.controllerUrl}/daterange/${endorsementId}`;

        try {
            let response: Response = await super.makeGetCall(url);
            return await response.json();
        }
        catch (error) {
            if (ErrorMessage.isErrorMessage(error)) {
                error.message = `Could not fetch allowed endorsement date range for endorsement # ${endorsementId}.`;
            }
            throw error;
        }
    }
}